// Shared working-days calculation used by the Gantt timeline (GanttChart.js)
// and the Eficiencia por Metraje metric (Estadisticas.js). Peru public holidays
// are treated like weekends: same timeline shading and excluded from the
// working-days count. Keeping a single source of truth avoids the two views
// drifting apart.

// Peru public holidays (YYYY-MM-DD). Treated like weekends — same cell shading
// and excluded from the working-days count.
export const FERIADOS_PERU = new Set([
  // 2025
  '2025-01-01', '2025-04-17', '2025-04-18', '2025-05-01', '2025-06-07',
  '2025-06-29', '2025-07-23', '2025-07-28', '2025-07-29', '2025-08-06',
  '2025-08-30', '2025-10-08', '2025-11-01', '2025-12-08', '2025-12-09',
  '2025-12-25',
  // 2026
  '2026-01-01', '2026-04-02', '2026-04-03', '2026-05-01', '2026-06-07',
  '2026-06-29', '2026-07-23', '2026-07-28', '2026-07-29', '2026-08-06',
  '2026-08-30', '2026-10-08', '2026-11-01', '2026-12-08', '2026-12-09',
  '2026-12-25',
]);

// Parse a YYYY-MM-DD string into a local-midnight Date (avoids UTC offset drift).
function toLocal(s) { return s ? new Date(s + 'T00:00:00') : null; }

function fmtDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Inclusive count of working days between two YYYY-MM-DD date strings.
// Saturdays/Sundays are excluded unless includeSat/includeSun is set; Peru
// holidays (FERIADOS_PERU) are always excluded. Returns '' if either date is
// missing, and 0 if the range is invalid/reversed.
export function daysBetween(a, b, includeSat = false, includeSun = false) {
  if (!a || !b) return '';
  const start = toLocal(a);
  const end = toLocal(b);
  if (!start || !end || end < start) return 0;
  let count = 0;
  const cur = new Date(start);
  while (cur <= end) {
    const dow = cur.getDay(); // 0 = Sun, 6 = Sat
    const isSat = dow === 6;
    const isSun = dow === 0;
    const skipWeekend = (isSat && !includeSat) || (isSun && !includeSun);
    if (!skipWeekend && !FERIADOS_PERU.has(fmtDate(cur))) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}
